import React from "react";
import PropTypes from 'prop-types';
// import { SortableElement } from 'react-sortable-hoc';
import { Button } from 'antd';
import moment from 'moment';
import { noteList as strings } from 'ui/constants/strings';


class NoteItem extends React.PureComponent {
  onTogglePin = () => {
    const { id } = this.props;
    this.props.togglePin(id);
  }

  onEditClick = () => {
    const { id } = this.props;
    this.props.onEdit(id);
  }

  onDeleteClick = () => {
    const { id } = this.props;
    this.props.onDelete(id);
  }

  renderMessage = () => {
    const { pin, message } = this.props;
    return (
      <div className='noteMessageContainer'>
        <div className={`pin ${pin ? 'pin' : 'unpin'}`} onClick={this.onTogglePin}>
        </div>
        <div className='noteMessage'>
          { message }
        </div>
      </div>
    )
  }

  renderDetail = () => {
    const { updatedAt } = this.props;
    return (
      <div className='noteDetailContainer'>
        <div className='author'>
        </div>
        <div className='time'>
          { moment(updatedAt).format('M/D HH:mm') }
        </div>
        <div className='actions'>
          <Button.Group size='small'>
            <Button size='small' onClick={this.onEditClick}>
              { strings.editButton }
            </Button>
            <Button size='small' onClick={this.onDeleteClick}>
              { strings.deleteButton }
            </Button>
          </Button.Group>
        </div>
      </div>
    )
  }

  render() {
    return(
      <div className='component-note'>
        { this.renderMessage() }
        { this.renderDetail()}
      </div>
    )
  }
}

NoteItem.defaultProps = {
  pin: false,
  togglePin: null,
  onEdit: () => {},
  onDelete: () => {},
};

NoteItem.propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  pin: PropTypes.bool,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  togglePin: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

// export default SortableElement(NoteItem);
export default NoteItem;
